import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { SidebarUser as UserSidebarType } from './ui/index.tsx';

const LazyUserSidebar = lazyAfterPaint<typeof UserSidebarType>(
	() => {
		setPerformanceMarkLoadStart();

		return import(/* webpackChunkName: "async-sidebar-user" */ './index').then((bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle;
		});
	},
	{ entryFsSsrLiftImportToModule: false },
);

const UserSidebar = memo(() => (
	<SidebarBoundary id="user">
		<LazyUserSidebar />
	</SidebarBoundary>
));

UserSidebar.displayName = 'UserSidebar';

export default UserSidebar;
